import { request } from "../helpers/axios.new";

export const FETCH_ESTIMATE = (estimateId) =>
  request({ url: `/estimates/estimate/${estimateId}` });
